import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

@Injectable()
export class ExcelService {

  constructor() { }

  public exportAsExcelFile(array: any[], fileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(array);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.writeFile(workbook, fileName + '_export_' + new Date().getTime() + '.xlsx');
  }
  public exportAsExcelFileWithMultiplePage(array: any[], fileName: string): void {
    const workbook: XLSX.WorkBook = { Sheets: {}, SheetNames: [] };
    array.forEach((arr) => {
      workbook.Sheets[arr.name] = XLSX.utils.aoa_to_sheet(arr.data);
      workbook.SheetNames.push(arr.name);
    });
    const excelBuffer: any = XLSX.writeFile(workbook, fileName + '.xlsx');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/excel.service.ts